import { EventItem } from "../models/models";

export const fetchData = async (sc: string | undefined, setFetching: (fetching: boolean) => void) => {

  if(!sc) return null;

  setFetching(true); 

  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/Export/seourl/${sc}`);
    if (!response.ok) {
      throw new Error("Errore nel caricamento del file JSON");
    }
    const data = await response.json();
    if (!data) {
      throw new Error("Errore nel caricamento dei dati");
    }

    if(data.events && data.events.length > 0){
      data.events = data.events.map((event: EventItem) => {
        const expireDate = new Date(event.expireDate);
        const isPassed = expireDate < new Date();
        return {
          ...event,
          passed: isPassed,
        };
      }).sort((a: EventItem, b: EventItem) => new Date(a.expireDate).getTime() - new Date(b.expireDate).getTime());
    }
 
    return data;
  } catch (error) {
    console.error("Errore nel caricamento dei dati:", error);
    throw error; 
  } finally {
    setFetching(false); 
  }
};
